export default class Stack {
	get length () {
		return this.pool.length;
	}

	constructor(size) {
		this.pool = new Array();
		this.size = size;
	}

	pop() {
		return this.pool.pop();
	}

	push(item) {
		if (this.pool.length == this.size)
			this.pool.shift();
		
		return this.pool.push(item);
	}

	clear() {
		this.pool = new Array();
	}
}
